import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { PageErrorState } from '@hh.ru/front-static-app/lib/types';
import { Button, GridLayout } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { INDEX_ROUTE } from 'src/app/routesUtils';
import Header from 'src/components/Header';
import PageWrapper from 'src/components/PageWrapper';
import { EMAIL_SUPPORT } from 'src/modules/emails';

import Error404 from 'src/components/PageError/404.svg';

import styles from './styles.less';

const TrlKeys = {
    dataInfo: 'career-platform.footer.dataInfo',
    button: {
        toMain: 'career-platform.page-error.404.go-to-main',
    },
    errors: {
        404: {
            title: 'career-platform.page-error.title.404.title',
            description: 'career-platform.page-error.title.404.description',
        },
    },
};

const PageError: TranslatedComponent<PageErrorState> = ({ trls }) => (
    <PageWrapper>
        <div className={styles.container}>
            <Header />
            <GridLayout>
                <div className={styles.content}>
                    <Error404 className={styles.icon} />
                    <p className={styles.error}>{trls[TrlKeys.errors[404].title]}</p>
                    <p className={styles.errorDescription}>
                        {trls[TrlKeys.errors[404].description]} <a href={`mailto:${EMAIL_SUPPORT}`}>{EMAIL_SUPPORT}</a>
                    </p>
                    <div className={styles.buttonContainer}>
                        <Button mode="primary" stretched Element={SPALink} to={INDEX_ROUTE} isSeoLink>
                            {trls[TrlKeys.button.toMain]}
                        </Button>
                    </div>
                </div>
            </GridLayout>
            <div className={styles.expander} />
            <footer className={styles.footer}>{trls[TrlKeys.dataInfo]}</footer>
        </div>
    </PageWrapper>
);

export default translation(PageError);
